import type {SavedAccountSummary} from '@AiChat/ai-chat.types';

export interface AiChatMemoryAccountSectionProps {
  account: SavedAccountSummary;
}

/** A kit can hold many colours; past this many the row shows a "+N" count so a long kit stays on one line. */
export const MEMORY_ACCOUNT_KIT_COLOR_LIMIT = 6;

export interface MemoryAccountSetUpAction {
  text: string;
  href: string;
}
